import React, { Component }
from "react";
import "./PrivacyPolicy.css";
import Header from "../Common/Header/HeaderForUnauthenticated";


class PrivacyPolicy extends Component {
    render() {
            return (
                    <div className="PrivacyPolicy">
   <Header pageHeading="Privacy Policy"  props={this.props}/>
   <div className="clearfix"></div>
   <div className="clearfix"></div>
   <div className="col-sm-12">
      <div className="col-xs-12  col-sm-12 privacypolicy_mrg_dashboard_right">
         <div className="clear40"></div>
         <div className="col-xs-12 col-sm-12 col-md-12">
            <div className="clear10"></div>
            <div className="privacy_policy">
               <h2>Privacy Policy</h2>
               <p>[Individual or Company Name] built the [App Name] app as a [open source | free | freemium | ad-supported | commercial] app. This SERVICE is provided by [Individual or company name] [at no cost] and is intended
                  for use as is.
               </p>
               <p>This page is used to inform website visitors regarding [my|our] policies with the collection, use, and
                  disclosure of Personal Information if anyone decided to use [my|our] Service.
               </p>
               <p>If you choose to use [my|our] Service, then you agree to the collection and use of information in
                  relation with this policy. The Personal Information that [I|we] collect are used for providing and
                  improving the Service. [I|We] will not use or share your information with anyone except as described
                  in this Privacy Policy.
               </p>
               <p>The terms used in this Privacy Policy have the same meanings as in our Terms and Conditions,
                  which is accessible at [App Name], unless otherwise defined in this Privacy Policy.
               </p>
               <p><strong>Information Collection and Use</strong></p>
               <p>For a better experience while using our Service, [I|we] may require you to provide us with certain
                  personally identifiable information, including but not limited to [add whatever else you collect here, e.g. users name | address | location | pictures]. 
                  The information that [I|we] request is [retained on your device and is not
                  collected by [me|us] in any way]|[will be retained by us and used as described in this privacy policy.
               </p>
               <p>The app does use third party services that may collect information used to identify you. [You can mention Google services here and link to Google's privacy policy if you want].</p>
               <p><strong>Log Data</strong></p>
               <p>[I|We] want to inform you that whenever you use [my|our] Service, in case of an error in the app [I|we] collect
                  data and information (through third party products) on your phone called Log Data. This Log Data
                  may include information such as your devices's Internet Protocol ("IP") address, device name,
                  operating system version, configuration of the app when utilising [my|our] Service, the time and date
                  of your use of the Service, and other statistics.
               </p>
               <p><strong>Cookies</strong></p>
               <p>Cookies are files with small amount of data that is commonly used an anonymous unique identifier.
                  These are sent to your browser from the website that you visit and are stored on your devices's
                  internal memory.
               </p>
               <p> This Services does not uses these "cookies" explicitly. However, the app may use third party code
                  and libraries that use "cookies" to collection information and to improve their services. You
                  have the option to either accept or refuse these cookies, and know when a cookie is being sent
                  to your device. If you choose to refuse our cookies, you may not be able to use some portions of
                  this Service.
               </p>
               <p><strong>Service Providers</strong></p>
               <p>[I|We] may employ third-party companies and individuals due to the following reasons:</p>
               <ul>
                  <li>To facilitate our Service;</li>
                  <li>To provide the Service on our behalf;</li>
                  <li>To perform Service-related services; or</li>
                  <li>To assist us in analyzing how our Service is used.</li>
               </ul>
               <p>[I|We] want to inform users of this Service that these third parties have access to your Personal
                  Information. The reason is to perform the tasks assigned to them on our behalf. However, they
                  are obligated not to disclose or use the information for any other purpose.
               </p>
               <p><strong>Security</strong></p>
               <p>[I|We] value your trust in providing us your Personal Information, thus we are striving to use
                  commercially acceptable means of protecting it. But remember that no method of transmission over
                  the internet, or method of electronic storage is 100% secure and reliable, and [I|we] cannot
                  guarantee its absolute security.
               </p>
               <p><strong>Links to Other Sites</strong></p>
               <p>This Service may contain links to other sites. If you click on a third-party link, you will be
                  directed to that site. Note that these external sites are not operated by [me|us]. Therefore, I
                  strongly advise you to review the Privacy Policy of these websites. I have no control over, and
                  assume no responsibility for the content, privacy policies, or practices of any third-party
                  sites or services.
               </p>
               <p><strong>Children's Privacy</strong></p>
               <p>This Services do not address anyone under the age of 13. [I|We] do not knowingly collect personal
                  identifiable information from children under 13. In the case [I|we] discover that a child under 13
                  has provided [me|us] with personal information, [I|we] immediately delete this from our servers. If you
                  are a parent or guardian and you are aware that your child has provided us with personal
                  information, please contact [me|us] so that [I|we] will be able to do necessary actions.
               </p>
               <p><strong>Changes to This Privacy Policy</strong></p>
               <p>[I|We] may update our Privacy Policy from time to time. Thus, you are advised to review this page
                  periodically for any changes. [I|We] will notify you of any changes by posting the new Privacy Policy
                  on this page. These changes are effective immediately, after they are posted on this page.
               </p>
               <p><strong>Contact Us</strong></p>
               <p>If you have any questions or suggestions about [my|our] Privacy Policy, do not hesitate to contact
                  [me|us].
               </p>
               <p>This Privacy Policy page was created at <a href={null} target="_blank">Digitalform.com</a>.</p>
            </div>
            <div className="clear10"></div>
         </div>
         <div className="clearfix"></div>
      </div>
      <div className="clear40"></div>
   </div>
   <div className="clear40"></div>
</div>
                    );
    }
}
;
export default PrivacyPolicy;
